/** The verification sessions of the two most recent texts. A code from
 * either verifies, so the one the visitor types may be from the text before
 * the latest. */
export type OtpSessions = { current: string; previous: string | null };

/** The sessions once another text has been sent. */
export function recordOtpSession(
  held: OtpSessions | null,
  sessionInfo: string,
): OtpSessions {
  const before = held?.current ?? null;
  return {
    current: sessionInfo,
    previous: before === sessionInfo ? (held?.previous ?? null) : before,
  };
}

/** The request fields that name the sessions a code is checked against. The
 * earlier session is left out when there is none. */
export function otpSessionFields(sessions: OtpSessions): {
  sessionInfo: string;
  previousSessionInfo?: string;
} {
  if (sessions.previous === null) return { sessionInfo: sessions.current };
  return {
    sessionInfo: sessions.current,
    previousSessionInfo: sessions.previous,
  };
}

/** The sessions once a text replaced a code that ended: the ended ones are
 * dropped, so a code is only ever checked against the new text. */
export function restartOtpSessions(sessionInfo: string): OtpSessions {
  return { current: sessionInfo, previous: null };
}
